export const getCountry = event => {
  if (
    !event ||
    !event.eventLocation ||
    event.eventLocation.type !== "address" ||
    !event.eventLocation.addressComponents
  ) {
    return false;
  }
  const addressComponents = event.eventLocation.addressComponents;
  const country = addressComponents.find(component =>
    component.types.includes("country")
  );
  if (country) {
    return country.long_name.toLowerCase();
  }
  return false;
};

export const getLocality = event => {
  if (
    !event ||
    !event.eventLocation ||
    event.eventLocation.type !== "address" ||
    !event.eventLocation.addressComponents
  ) {
    return false;
  }
  const addressComponents = event.eventLocation.addressComponents;
  const locality = addressComponents.find(component =>
    component.types.includes("locality")
  );
  if (locality) {
    return locality.long_name.toLowerCase();
  }
  return false;
};

export const getLocationStr = location => {
  const parts = [];
  if (location.type === "online") {
    if (location.instructions && location.instructions.length) {
      parts.push(location.instructions);
    }
    if (location.onlineUrl && location.onlineUrl.length) {
      parts.push(location.onlineUrl);
    }
  } else {
    if (location.venueName) {
      parts.push(location.venueName);
    }
    if (location.address) {
      parts.push(location.address);
    }
  }
  return parts.join(" ");
};

export const getSortLocationStr = location => {
  const parts = [];
  if (location.type === "online") {
    parts.push("Online");
  } else {
    if (location.venueName) {
      parts.push(location.venueName);
    }
    if (location.address) {
      parts.push(location.address);
    }
  }
  return parts.join(" ");
};
